<template>
    <el-dialog :title="$t('pointsManagement.bindVehicles')" :visible.sync="visible" width="700px">
        <div class="bind-vehicle-dialog">
            <div class="current-point-info" v-if="point">
                <span class="label">{{ $t('pointsManagement.currentPoint') }}:</span>
                <span class="value">{{ point.WayPointName }}</span>
            </div>

            <div class="vehicle-select-area">
                <div class="search-row">
                    <el-select v-model="boundStatus" placeholder="请选择绑定状态" size="small" style="width: 120px;">
                        <el-option label="全部" value="1"></el-option>
                        <el-option label="已绑定" value="2"></el-option>
                        <el-option label="未绑定" value="3"></el-option>
                    </el-select>
                    <el-input v-model="vehicleSearchKeyword" :placeholder="$t('pointsManagement.searchVehicle')"
                        size="small" clearable style="width: 200px;">
                        <el-button slot="append" icon="el-icon-search" @click="queryVehicleList"></el-button>
                    </el-input>
                </div>

                <el-table :data="vehicleList" style="width: 100%" :row-key="(row) => row.VehicleID"
                    :default-checked-keys="getDefaultCheckedVehicleIds()" border
                    @selection-change="handleVehicleSelectionChange">
                    <el-table-column type="selection" :selectable="canSelectVehicle"
                        @click.native.stop></el-table-column>
                    <el-table-column prop="CarNo" :label="$t('pointsManagement.vehicleNo')"
                        min-width="120"></el-table-column>
                    <el-table-column prop="boundPoint" label="绑定状态" min-width="120">
                        <template slot-scope="scope">
                            <el-tag size="small" :type="scope.row.IsBound == 1 ? 'success' : 'danger'">
                                {{ scope.row.IsBound == 1 ? '已绑定' : '未绑定' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>

                <kl-pagination :total="totalVehicle" :page-size="vehiclePageSize"
                    @current-change="handleVehiclePageChange" :current-page.sync="vehiclePage"
                    @size-change="handleVehiclePageSizeChange">
                </kl-pagination>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="$emit('update:visible', false)">关闭</el-button>
            <el-button type="primary" size="small" @click="confirmBindVehicles" :loading="binding">
                确定绑定</el-button>
            <el-button type="danger" size="small" @click="confirmUnbindVehicles" :loading="binding">
                解除绑定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { queryVehicleRePointsInfo, setVehicleRePointsInfo } from '@/http/vehicle';

export default {
    name: 'VehicleBindDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        point: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            vehicleList: [],
            totalVehicle: 0,
            vehiclePage: 1,
            vehiclePageSize: 10,
            vehicleSearchKeyword: '',
            boundStatus: '1',
            binding: false,
            selectedVehiclesForBind: []
        };
    },
    watch: {
        visible(val) {
            if (val && this.point) {
                this.vehicleSearchKeyword = '';
                this.vehiclePage = 1;
                this.queryVehicleList();
            }
        },
        point() {
            if (this.visible) {
                this.vehiclePage = 1;
                this.queryVehicleList();
            }
        }
    },
    methods: {
        queryVehicleList() {
            if (!this.point) return;
            queryVehicleRePointsInfo({
                CarNo: this.vehicleSearchKeyword,
                WayPointID: this.point.WayPointID,
                Flag: parseInt(this.boundStatus),
                PageNo: this.vehiclePage,
                PageSize: this.vehiclePageSize
            }).then(res => {
                this.vehicleList = res.data || [];
                this.totalVehicle = res.recordsTotal || 0;
            });
        },
        handleVehiclePageChange(page) {
            this.vehiclePage = page;
            this.queryVehicleList();
        },
        handleVehiclePageSizeChange(size) {
            this.vehiclePageSize = size;
            this.vehiclePage = 1;
            this.queryVehicleList();
        },
        canSelectVehicle(row) {
            if (!this.point) return false;
            if (!row.boundPointId) return true;
            return row.boundPointId === this.point.id;
        },
        getDefaultCheckedVehicleIds() {
            if (!this.point || !this.point.boundVehicles) return [];
            return this.point.boundVehicles.map(v => v.vehicleId);
        },
        handleVehicleSelectionChange(selection) {
            this.selectedVehiclesForBind = selection;
        },
        confirmBindVehicles() {
            if (!this.point) return;
            this.binding = true;
            const data = this.selectedVehiclesForBind.map(v => ({
                VehicleID: v.VehicleID,
                WayPointID: this.point.WayPointID
            }));
            setVehicleRePointsInfo({ data, Flag: 1 }).then(() => {
                this.binding = false;
                this.queryVehicleList();
                this.$message.success(this.$t('pointsManagement.bindSuccess'));
                this.$emit('update');
            });
        },
        confirmUnbindVehicles() {
            if (!this.point) return;
            this.binding = true;
            const data = this.selectedVehiclesForBind.map(v => ({
                VehicleID: v.VehicleID,
                WayPointID: this.point.WayPointID
            }));
            setVehicleRePointsInfo({ data, Flag: 2 }).then(() => {
                this.binding = false;
                this.queryVehicleList();
                this.$message.success(this.$t('pointsManagement.unbindSuccess'));
                this.$emit('update');
            });
        }
    }
};
</script>

<style scoped>
.bind-vehicle-dialog {
    max-height: 500px;
    overflow-y: auto;
}

.current-point-info {
    margin-bottom: 16px;
    padding: 12px;
    background: #f5f7fa;
    border-radius: 4px;
}

.current-point-info .label {
    font-size: 14px;
    color: #606266;
    margin-right: 8px;
}

.current-point-info .value {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

.vehicle-select-area {
    margin-bottom: 20px;
}

.search-row {
    margin-bottom: 12px;
}
</style>